import React from 'react';
import { Button, Dimmer } from 'semantic-ui-react';
import styled from 'styled-components';
import userContextSlice from '../slices/userContextSlice';
import { useDispatch } from 'react-redux';

const TransitionScreen = ({
  message = 'Preparing your nuLogic experience',
  isError = false,
  signOut,
}) => {
  const dispatch = useDispatch();
  const resetAndReload = async () => {
    try {
      // Clear Redux state first
      dispatch(userContextSlice.actions.clearUserContext());

      // Clear any stored tokens
      localStorage.removeItem('cognito_token');
      localStorage.removeItem('selected_org_id');

      // Wait for signOut to complete
      await signOut();

      // Use a small timeout to ensure all state changes have propagated
      setTimeout(() => {
        // Reload the application
        window.location.href = '/';
      }, 100);
    } catch (error) {
      console.error('Error during reset and reload:', error);
      // Force reload even if there's an error
      window.location.href = '/';
    }
  };

  return (
    <TransitionWrapper>
      <Dimmer active={true} inverted={true}>
        <ContentContainer>
          <AnimatedLogo isError={isError}>
            <Logo isError={isError} />
          </AnimatedLogo>
          <Message isError={isError}>{message}</Message>
          {isError && <RetryButton onClick={resetAndReload}>Try Again</RetryButton>}
        </ContentContainer>
      </Dimmer>
    </TransitionWrapper>
  );
};

const TransitionWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: #ffffff;
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Message = styled.div`
  font-size: 24px;
  font-weight: 500;
  color: ${props => (props.isError ? '#e74c3c' : '#333')};
  margin-top: 20px;
  text-align: center;
  font-family: 'Poppins', sans-serif;
`;

const AnimatedLogo = styled.div`
  animation: ${props => (props.isError ? 'shake 0.5s' : 'pulse 2s infinite')};

  @keyframes pulse {
    0% {
      transform: scale(1);
    }
    50% {
      transform: scale(1.1);
    }
    100% {
      transform: scale(1);
    }
  }

  @keyframes shake {
    0% {
      transform: translateX(0);
    }
    25% {
      transform: translateX(-10px);
    }
    50% {
      transform: translateX(10px);
    }
    75% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0);
    }
  }
`;

// Simple placeholder logo - replace with your actual logo if needed
const Logo = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: ${props =>
    props.isError
      ? 'linear-gradient(135deg, #e74c3c 0%, #c0392b 100%)'
      : 'linear-gradient(135deg, #6e8efb 0%, #a777e3 100%)'};
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const RetryButton = styled(Button)`
  margin-top: 30px !important;
  background-color: #3498db !important;
  color: white !important;
  font-family: 'Poppins', sans-serif !important;
  font-weight: 500 !important;
  padding: 12px 24px !important;
  border-radius: 4px !important;
  transition: background-color 0.3s !important;

  &:hover {
    background-color: #2980b9 !important;
  }
`;

export default TransitionScreen;
